const SET_DEVICE = "SET_DEVICE";

export { SET_DEVICE };
